import { render } from "./TableItemControls.vue?vue&type=template&id=787a0d71"
import script from "./TableItemControls.vue?vue&type=script&lang=js"
export * from "./TableItemControls.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__